@if (isOrderPaymentMode && !titleHidden) {
  <p class="is-body-s is-semi-bold">
    {{ 'payment.paymentMode' | translate }}
  </p>
}
@if (!isOrderPaymentMode && !titleHidden) {
  <p class="brand--h5">
    {{ 'payment.ourPaymentMode' | translate }}
  </p>
}
<div class="c__content is-col col-s-24 col-m-6 col-l-20">
  @if (paymentMode?.paymentProvider && paymentMode?.selectedPaymentMode && isOrderPaymentMode && !titleHidden) {
    <p class="is-body-s">
      {{ 'payment.method.' + (paymentMode?.paymentProvider | lowercase) + '.' + paymentMode?.selectedPaymentMode + '.name' | translate }}
    </p>
  }
  @if (paymentMode?.medias?.length > 1) {
    <ul sd-list-inline>
      @for (media of paymentMode.medias; track media) {
        <li>
          <sd-banner [media]="media" [imgRatio]="imageRatio.r1_1" [isFit]="true" />
        </li>
      }
    </ul>
  }

  @if (paymentMode?.medias?.length === 1) {
    <sd-banner [media]="paymentMode?.medias[0]" [isFit]="true" />
  }
</div>

@if (paymentMode?.voucher && isOrderPaymentMode) {
  <div class="c__content">
    <p  class="is-body-s">
      {{ 'payment.voucher' | translate }} <b>{{ paymentMode?.voucher}}</b>
    </p>
  </div>
}
